export const categoryCaseListItem = arr => {
  return arr.reduce((r, a) => {
    r[a.categoryId] = [...(r[a.categoryId] || []), a];
    return r;
  }, {});
};
